import React from 'react';

import './Meter.scss';

type Props = {
  totalPercentage: number;
};

export default ({ totalPercentage }: Props) => {
  const value = (totalPercentage / 100) * 80;
  return (
    <div className="meter-circle mx-auto">
      <svg width="100%" height="100%" viewBox="0 0 42 42" className="donut">
        <circle
          className="donut-segment"
          cx="21"
          cy="21"
          r="15.91549430918954"
          fill="transparent"
          stroke="#DEE4E4"
          strokeWidth="2"
          strokeDasharray="80 20"
          strokeDashoffset="65"
          strokeLinecap="round"
        />
        {value > 0 && (
          <>
            <linearGradient id="linear-gradient" x1="0" y1="1" x2="1" y2="0.5">
              <stop offset="30%" stopColor="#65A3A7" />
              <stop offset="70%" stopColor="#A0DFAA" />
            </linearGradient>
            <circle
              className="donut-segment"
              cx="21"
              cy="21"
              r="15.91549430918954"
              fill="transparent"
              stroke="url(#linear-gradient)"
              strokeWidth="2"
              strokeDasharray={`${Math.min(value, 80)} ${100 - Math.min(value, 80)}`}
              strokeDashoffset="65"
              strokeLinecap="round"
            />
          </>
        )}
      </svg>
      <div className="circle-data">
        <div className="percentage">{`${totalPercentage}%`}</div>
        <div className="small text-muted time">CRM Quality Score</div>
        <div className="small goal">Goal</div>
        <div className="small text-muted">100%</div>
      </div>
    </div>
  );
};
